import React, { useEffect, useRef, useState } from 'react';

import OnboardCell from '../../components/onboardCell';
import StakingCell from '../../components/stakingCell';
import ProofTable from '../../components/proofTable';
import NewsletterCell from '../../components/newsletterCell';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { isStaked } from '../../httpcalls/contractThunk';
import { resetStaking } from '../../store/schemas/stakingSlice';
import { ClientOnly } from '../../../library/client/serverCallHandler';
import { MetaTagHandler } from '../../../library/client/serverCallHandler';
import Footer from '../../components/footer';
import B_Staked from './b_staked';
import Tilt from 'react-parallax-tilt';
import B_Rewards from './b_rewards/b_rewards';
import B_Manage from './b_manage/b_manage';
import B_Resources from './b_resources';
import ScanStrip from '../../components/global/scanStrip';



const StakingDashboard = () => {
    const dispatch = useDispatch()
    const isStakeholder = useSelector(state => state.mainapp.stakingSlice.isStakeholder);

    const network = useSelector(state => state.authManagement.network)
    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const stakeholderNotWaitList = useSelector(state => state.mainapp.stakingSlice.stakeholderNotWaitList)
    return (
        <>



            <MetaTagHandler>
                {() => (
                    <>
                        <title>Stakeholder Dashboard | PLURI</title>
                        <meta name="description" content="Being a Pluri stakeholder provides a profitable investment opportunity with assured regular rewards, stability and transparency, and a strong emphasis on data integrity and security." />
                        <meta property="og:title" content="PLURI | Stakeholders" />
                        <meta property="og:description" content="Being a Pluri stakeholder provides a profitable investment opportunity with assured regular rewards, stability and transparency, and a strong emphasis on data integrity and security." />
                        <meta property="og:image" content={`https://${process.env.REACT_APP_ORIGIN}/assets/pluriBanner.png`} />
                        <meta property="og:url" content={`https://${process.env.REACT_APP_ORIGIN}/stakeholders`} />
                        <meta property="og:site_name" content="PLURI" />
                        <meta property="og:type" content="website" />
                        <meta property="og:locale" content="en_US" />

                    </>
                )}
            </MetaTagHandler>



            <ScanStrip />
            <div className='bento-container'>
                <h1 className='bento-title'>
                    STAKEHOLDER
                </h1>
                <div className='bento-flow'>
                    <Tilt scale={1.02} tiltMaxAngleX={1}
                        tiltMaxAngleY={1} >
                        <div className='bento-cell'>
                            <B_Staked />
                        </div>
                    </Tilt>
                    <Tilt scale={1.02} tiltMaxAngleX={1}
                        tiltMaxAngleY={1}>
                        <div className='bento-cell'>
                            <B_Rewards />
                        </div>
                    </Tilt>
                </div>
                {
                    stakeholderNotWaitList ? <div className='bento-flow-alt' style={
                        { flexDirection: 'column-reverse' }
                    } >
                        <Tilt scale={1.02} tiltMaxAngleX={1}
                            tiltMaxAngleY={1} >
                            <div className='bento-cell'>
                                <B_Manage />
                            </div>
                        </Tilt>
                        <Tilt scale={1.02} tiltMaxAngleX={1}
                            tiltMaxAngleY={1}>
                            <div className='bento-cell'>
                                <B_Resources />
                            </div>
                        </Tilt>
                    </div> : null
                }

            </div>


            <style>
                {
                    `
                    .dash-label {
                        max-width: 1270px
                    }
                    .p-table-container
                    {
                        max-width: 1270px;
                  
                    }
                    .p-table-header {
                        border:none
                    }
                    `

                }
            </style>
        </>
    );
};

export default StakingDashboard;
